import api from './api';

const resourcesService = {
  getMeta: () => api.get('/resources/meta').then(response => response.data),
  getCategories: () => api.get('/resources/categories').then(response => response.data),
  getArticles: (params = {}) => api.get('/resources/articles', { params }).then(response => response.data),
  getArticle: (slug) => api.get(`/resources/articles/${slug}`).then(response => response.data),
  getFeed: (feed) => api.get(`/resources/feeds/${feed}`).then(response => response.data),
  getManagedArticles: () => api.get('/resources/manage/articles').then(response => response.data),
  getManagedArticle: (id) => api.get(`/resources/manage/articles/${id}`).then(response => response.data),
  createArticle: (data) => api.post('/resources/manage/articles', data).then(response => response.data),
  updateArticle: (id, data) => api.put(`/resources/manage/articles/${id}`, data).then(response => response.data),
  getRevisions: (id) => api.get(`/resources/manage/articles/${id}/revisions`).then(response => response.data),
  getRevision: (id, revisionId) => api.get(`/resources/manage/articles/${id}/revisions/${revisionId}`).then(response => response.data),
  restoreRevision: (id, revisionId) => api.post(`/resources/manage/articles/${id}/revisions/${revisionId}/restore`).then(response => response.data),
  getManagedCategories: () => api.get('/resources/manage/categories').then(response => response.data),
  createCategory: (data) => api.post('/resources/manage/categories', data).then(response => response.data),
  updateCategory: (id, data) => api.put(`/resources/manage/categories/${id}`, data).then(response => response.data),
  reorderCategories: (categoryIds) => api.put('/resources/manage/categories/reorder', { category_ids: categoryIds }).then(response => response.data),
  getMedia: (params = {}) => api.get('/resources/media', { params }).then(response => response.data),
  uploadMedia: (file, metadata = {}) => {
    const form = new FormData();
    form.append('file', file);
    Object.entries(metadata).forEach(([key, value]) => {
      if (value !== undefined && value !== null) form.append(key, value);
    });
    return api.post('/resources/media', form, { headers: { 'Content-Type': 'multipart/form-data' } }).then(response => response.data);
  },
  updateMedia: (id, data) => api.put(`/resources/media/${id}`, data).then(response => response.data),
  downloadMedia: (id, download = false, { thumb = false } = {}) => api.get(`/resources/media/${id}/file`, { params: { ...(download ? { download: 1 } : {}), ...(thumb ? { thumb: thumb === true ? 1 : thumb } : {}) }, responseType: 'blob' }).then(response => response.data),
};

export default resourcesService;
